// GENERATED by scripts/build-icons.mjs from icons/cable.svg — do not edit.
// Lucide (ISC); Feather-derived icons additionally MIT. See LICENSE-lucide.
import { createIcon } from '../createIcon'

export const Cable = createIcon('cable', [
  ['path', { d: "M17 19a1 1 0 0 1-1-1v-2a2 2 0 0 1 2-2h2a2 2 0 0 1 2 2v2a1 1 0 0 1-1 1z" }],
  ['path', { d: "M17 21v-2" }],
  ['path', { d: "M19 14V6.5a1 1 0 0 0-7 0v11a1 1 0 0 1-7 0V10" }],
  ['path', { d: "M21 21v-2" }],
  ['path', { d: "M3 5V3" }],
  ['path', { d: "M4 10a2 2 0 0 1-2-2V6a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v2a2 2 0 0 1-2 2z" }],
  ['path', { d: "M7 5V3" }],
])
